/**
 * List of entry types
 */
export const ENTRY_TYPES = {
    EVENT: 'event',
    ERROR: 'error',
    MEASURE: 'measure',
};

/**
 * Accepted event types
 */
export const EVENT_TYPES = [ENTRY_TYPES.EVENT, ENTRY_TYPES.ERROR];

/**
 * Error codes used when logging errors
 */
export const ERROR_CODES = {
    START_SPAN: 'START_SPAN_ERROR',
    END_SPAN: 'END_SPAN_ERROR',
    ADD_EVENT: 'ADD_EVENT_ERROR',
    ADD_ERROR: 'ADD_ERROR_ERROR',
    CLEAR_MARK: 'CLEAR_MARK_ERROR',
};
